import { useTranslation } from '@frontend/i18n';
import { Icon } from '@frontend/icons';
import { theme } from '@frontend/theme';
import { TextLink } from '@frontend/design-system';

export interface CalendarToggleProps {
  showCalendarView: boolean;
  onToggle: () => void;
  hasPermission: boolean;
  isSmallMode?: boolean;
  disabled?: boolean;
}

/**
 * Reusable calendar view toggle component
 * Consolidates the repeated calendar toggle UI pattern
 */
export const CalendarToggle = ({
  showCalendarView,
  onToggle,
  hasPermission,
  isSmallMode = false,
  disabled = false,
}: CalendarToggleProps) => {
  const { t } = useTranslation('phone');

  return (
    <TextLink
      disabled={!hasPermission || disabled}
      onClick={onToggle}
      size={'large'}
      css={{
        display: 'flex',
        gap: theme.spacing(0.5),
        width: '200px',
        alignItems: 'center',
        whiteSpace: 'nowrap',
      }}
      weight='bold'
      trackingId='phone::setting::phone-hours:toggle-calendar-view-btn'
    >
      <Icon name={showCalendarView && !isSmallMode ? 'collapse-right' : 'expand'} color='primary' />
      {isSmallMode ? t('Show Calendar View') : showCalendarView ? t('Hide Calendar View') : t('Show Calendar View')}
    </TextLink>
  );
};
